<h2 class="background_title">
  {{this.tutorialID ? ('CONFIGURE.EDIT_TUTORIAL' | translate) : ('CONFIGURE.NEW_TUTORIAL' | translate) }}</h2>
<div>
  <form [formGroup]="addTutorialForm" class="form-container" name="addTutorialForm" #ngForm="ngForm">
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <mat-form-field class="example-full-width">
            <mat-label>{{ 'CONFIGURE.TITLE' | translate }}</mat-label>
            <input matInput inputSanitizer type="text" formControlName="title"
              maxlength="40" name="title" required
              placeholder="{{ 'CONFIGURE.ENTER.TITLE_2' | translate }} (Max 40)"
              [ngClass]="{'is-invalid':addTutorialForm.get('title').errors && (addTutorialForm.get('title').touched || addTutorialForm.get('title').dirty || ngForm.submitted)}">
            <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 40)</mat-hint>
          </mat-form-field>

          <div class="invalid-feedback"
            *ngIf="addTutorialForm.get('title').errors && (addTutorialForm.get('title').touched ||addTutorialForm.get('title').dirty || ngForm.submitted)">
            <span *ngIf="addTutorialForm.get('title').errors.required">
              {{ 'ERROR_MESSAGES.REQUIRED.TITLE' | translate }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <mat-form-field class="example-full-width">
            <mat-label>{{ 'CONFIGURE.DESCRIPTION' | translate }}</mat-label>
            <input matInput inputSanitizer type="text" formControlName="description" name="description"
              placeholder="{{ 'CONFIGURE.WRITE_COMMENTS_HERE' | translate }}" maxlength="1000"
              [ngClass]="{'is-invalid':addTutorialForm.get('description').errors && (addTutorialForm.get('description').touched || addTutorialForm.get('description').dirty || ngForm.submitted)}">
            <mat-hint align="end">({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 1000)</mat-hint>
          </mat-form-field>

          <div class="form-control-descrition-msgs">
            <div class="invalid-feedback"
              *ngIf="addTutorialForm.get('description').errors && (addTutorialForm.get('description').touched ||addTutorialForm.get('description').dirty || ngForm.submitted)">
              <span *ngIf="addTutorialForm.get('description').errors.required">
                {{ 'ERROR_MESSAGES.REQUIRED.DESCRIPTION' | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 col-sm-12">
        <div class="form-group w-100">
          <div class="dropdown dropdown-bhp top-12px">
              <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                  <input class="dropdown-toggle" type="text" [ngModel]="fileFormatName" formControlName="type" readonly
                  [ngClass]="{'is-invalid':addTutorialForm.get('type').errors && (addTutorialForm.get('type').touched || addTutorialForm.get('type').dirty || ngForm.submitted)}" />
                  <span class="label-dropdown">{{ 'INSTITUTION_MANAGEMENT.TYPE' | translate }}*</span>
                  <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
              </div>
              <ul class="dropdown-menu">
                <li class="dropdown-item" value="pdf" (click)="onFormatChange('pdf')" >{{'pdf'}}</li>
                <li class="dropdown-item" value="video" (click)="onFormatChange('video')" >{{'video (.mp4,.webm)'}}</li>
              </ul>
          </div>
          <div class="invalid-feedback pt-4"
            *ngIf="addTutorialForm.get('type').errors && (addTutorialForm.get('type').touched ||addTutorialForm.get('type').dirty || ngForm.submitted)">
            <span *ngIf="addTutorialForm.get('type').errors.required">
              {{ 'ERROR_MESSAGES.REQUIRED.TYPE' | translate }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
          <label>{{ 'CONFIGURE.CHOOSE_FILE' | translate }}</label>
          <div class="d-flex align-items-center">
            <div class="col-auto uploadBtnAlign p-0">
              <input #file type="file" accept="{{fileAccept()}}" class="ffinaorm-control" formControlName="fileURL"
                (change)="uploadfile(file.files)"
                [ngClass]="{'is-invalid':addTutorialForm.get('fileURL').errors && (addTutorialForm.get('fileURL').touched || addTutorialForm.get('fileURL').dirty || ngForm.submitted)}" />
              <div class="addBtn form-control">{{ 'CONFIGURE.BROWSE' | translate }}</div>
            </div>
            <div class="col-6 pr-0">
              <input matInput inputSanitizer type="text" formControlName="fileName" readonly>
            </div>
          </div>
          <div class="invalid-feedback pt-3"
            *ngIf="addTutorialForm.get('fileName').errors && (addTutorialForm.get('fileName').touched ||addTutorialForm.get('fileName').dirty || ngForm.submitted)">
            <span *ngIf="addTutorialForm.get('fileName').errors.required">
              File Name {{'ERROR_MESSAGES.SUFFIX.IS_REQUIRED' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 col-sm-12">
        <form>
          <div class="form-group">
            <mat-form-field class="example-full-width">
              <mat-label>{{ 'CONFIGURE.TAGS' | translate }}</mat-label>
              <input matInput inputSanitizer type="text" formControlName="name" maxlength="40" name="title"
                (keyup.enter)="onInputTagKeyup($event.target)">
            </mat-form-field>
            <br>
            <mat-chip-list aria-label="Fish selection">
              <mat-chip [selectable]="true" (click)="remove(item)" *ngFor="let item of items" [removable]="true"
                [color]="">{{item.value}} ⓧ</mat-chip>
            </mat-chip-list>
          </div>
        </form>
      </div>
    </div>

    <div class="row justify-content-end buttons-section">
      <div class="d-flex justify-content-end">
        <button (click)="cancelModal()" class="btn-cancel-bd separate-buttons"> {{ translationKeys.Authorization.Cancel
          | translate }}</button>
        <button (click)="submitTutorial(file.files)" class="btn-continue-bordered-bd">{{
          translationKeys.Authorization.Save | translate }}</button>
      </div>
    </div>
  </form>
</div>


<ng-template #cancelmodal>
  <div class="modal-header justify-content-between align-items-center mb-4">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body" data-simplebar>
    <p>{{'INSTITUTION_MANAGEMENT.INFORMATION_UNSAVED_CHANGES_LOST_AFTER_LEAVING' | translate}}</p>
  </div>
  <div class="modal-footer">
    <button (click)="modalRef.hide()" class="btn btn-cancel-bordered-bd mr-4">{{ 'LAYOUT_MODULE.STAY' | translate }}</button>
    <button (click)="backToTutorials();modalRef.hide()" class="btn btn-continue-bordered-bd ">{{ 'LAYOUT_MODULE.LEAVE' | translate }}</button>
  </div>
</ng-template>
